export const getErrorMessage = (e) => {
    // Log the error for debugging purposes
    console.error('API Error:', e);

    if (e.message === "Network Error") {
        return "No hay conexión a internet. Por favor, verifica tu conexión y vuelve a intentarlo.";
    } else if (e.response) {
        // Handle specific HTTP status codes
        switch (e.response.status) {
            case 400:
                // Try to extract specific validation errors if available
                if (e.response.data?.errors) {
                    const errorMessages = Object.values(e.response.data.errors).flat();
                    if (errorMessages.length > 0) {
                        return errorMessages.join(", ");
                    }
                }
                if (e.response.data?.email) {
                    return e.response.data?.email || "La solicitud contiene errores. Por favor, verifica los datos ingresados.";
                }
                return e.response.data?.message || "La solicitud contiene errores. Por favor, verifica los datos ingresados.";

            case 401:
                return "Sesión expirada. Por favor, inicia sesión nuevamente.";

            case 403:
                return "No tienes permisos para realizar esta acción.";

            case 404:
                return "El recurso solicitado no fue encontrado.";

            case 405:
                return "Método no permitido para esta solicitud.";

            case 422:
                // Handle validation errors
                if (e.response.data?.errors) {
                    const errorMessages = Object.values(e.response.data.errors).flat();
                    if (errorMessages.length > 0) {
                        return errorMessages.join(", ");
                    }
                }
                return "Los datos ingresados no son válidos. Por favor, verifica la información.";

            case 429:
                return "Demasiadas solicitudes. Por favor, espera un momento e intenta nuevamente.";

            case 500:
                return "Error interno del servidor. Por favor, intenta más tarde o contacta a soporte.";

            case 503:
                return "Servicio temporalmente no disponible. Por favor, intenta más tarde.";

            default:
                // Try to extract message from response if available
                if (e.response?.data?.message) {
                    return e.response.data.message;
                } else if (typeof e.response?.data === 'string') {
                    return e.response.data;
                } else {
                    return `Error en la solicitud (${e.response.status}).`;
                }
        }
    } else if (e.request) {
        // Request was made but no response was received
        return "No se recibió respuesta del servidor. Por favor, verifica tu conexión e intenta nuevamente.";
    } else {
        // Something happened in setting up the request
        return e.message || "Ocurrió un error inesperado. Por favor, intenta nuevamente.";
    }
};

export const filterTextHandler = (text, searchKey) => {
    if (!text) return false;
    return (
        text
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .indexOf(
                searchKey
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
            ) !== -1
    );
};

export const filterSelectOptionHandler = (input, option) => filterTextHandler(option.children, input);

export const getSecuredEmail = (email) => {
    if (!email) return "";
    const arr = email.split("@");
    return `${arr[0][0]}******@${arr[1]}`;
};

export const checkValidPassword = (password) => {
    return RegExp(/^(?=.*[a-zA-Z0-9])(?=.*[A-Z])(?=.*[!@#$&*]).{8,}$/).test(password);
};

export const cleanRUT = (rut) => rut.replace(/\./g, "").replace(/-/g, "").toUpperCase();

export const checkValidRUT = (rut) => {
    const cleanedRUT = cleanRUT(rut);

    // Separate the RUT body and the check digit
    const body = cleanedRUT.slice(0, -1);
    const checkDigit = cleanedRUT.slice(-1);

    // Validate the format (only numbers for body, and valid check digit)
    if (!/^\d+$/.test(body) || !/^[0-9K]$/.test(checkDigit)) {
        return false;
    }

    // Perform modulus-11 algorithm to calculate expected check digit
    let sum = 0;
    let multiplier = 2;

    // Iterate over the body digits from right to left
    for (let i = body.length - 1; i >= 0; i--) {
        sum += parseInt(body[i], 10) * multiplier;
        multiplier = multiplier === 7 ? 2 : multiplier + 1; // Cycle multiplier between 2 and 7
    }

    const mod11 = 11 - (sum % 11);
    const expectedCheckDigit = mod11 === 11 ? "0" : mod11 === 10 ? "K" : mod11.toString();

    // Compare the expected check digit with the given one
    return expectedCheckDigit === checkDigit;
};

export const formatRUT = (string) => {
    if (!string) return false;
    let cleanedRUT = string.replace(/[^0-9kK]/g, "");

    let rutNumber = cleanedRUT.slice(0, -1);
    let verificationDigit = cleanedRUT.slice(-1);

    let formattedRutNumber = rutNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // Combine the formatted number with the verification digit
    return `${formattedRutNumber}-${verificationDigit}`;
};
